import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import { IciFlags } from 'src/generated/signalR/ici-flags';
import { CallInformationRemoteDto } from 'src/generated/signalR/call-information-remote-dto';

@Pipe({
   name: 'iciExtraInfoText',
})
export class IciExtraInfoTextPipe implements PipeTransform {
   constructor(private translateService: TranslateService) {}

   transform(info: CallInformationRemoteDto): string {
      if (_.isNil(info)) {
         info = {
            ici: IciFlags.UNKNOWN,
            number: '',
            name: '',
         };
      }
      const parts: string[] = [];

      if (info.ici & IciFlags.PARK_PRIVATE) {
         parts.push(this.translateService.instant('samwin.types.ici.prefix.park_private'));
      } else if (info.ici & IciFlags.PARK_PUBLIC) {
         parts.push(this.translateService.instant('samwin.types.ici.prefix.park_skill'));
      }

      if (info.ici & IciFlags.FALLBACK) {
         parts.push(this.translateService.instant('samwin.types.ici.fallback'));
      }

      let result: string = parts.join(' ');

      if (info.ici & IciFlags.FORWARDED) {
         if (info.number) {
            result += this.translateService.instant('samwin.types.ici.append.forwarded_by', { peer: this.formatPeer(info.number, info.name) });
         } else {
            result += this.translateService.instant('samwin.types.ici.append.forwarded');
         }
      }

      if (info.ici & IciFlags.TRANSFERRED) {
         if (info.number) {
            result += this.translateService.instant('samwin.types.ici.append.transferred_by', { peer: this.formatPeer(info.number, info.name) });
         } else {
            result += this.translateService.instant('samwin.types.ici.append.transferred');
         }
      }

      if (info.ici & IciFlags.REJECTED) {
         result += this.translateService.instant('samwin.types.ici.append.rejected');
      }

      if (info.ici & IciFlags.BUSY) {
         result += this.translateService.instant('samwin.types.ici.append.busy');
      }

      if (info.ici & IciFlags.NO_ANSWER) {
         result += this.translateService.instant('samwin.types.ici.append.no_answer');
      }

      if (info.ici & IciFlags.CALLBACK) {
         result += ` (${this.translateService.instant('samwin.types.ici.callback')})`;
      }

      return result;
   }

   private formatPeer(num: string, name: string): string {
      if (!_.isNil(name)) {
         return `${name} (${num})`;
      }
      return num;
   }
}
